import { defineAsyncComponent } from 'vue'
export default {
  about: defineAsyncComponent(() => import("D:/.jenkins/workspace/web-prod-xkira-official-website/layouts/about.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("D:/.jenkins/workspace/web-prod-xkira-official-website/layouts/default.vue").then(m => m.default || m))
}